export default __webpack_public_path__ + "static/media/dashboard.2252e184.svg";